<script lang="ts">
  import clsx from 'clsx';
  import { type FullwidthCarouselItemProps } from './types';

  const { children, class: className, innerClass }: FullwidthCarouselItemProps = $props();
</script>

<!-- 
  The last:pr expression here is to create a fake padding to offset the translate-x down below. Which means that instead of ending the carousel
  at the edge of the screen it ends at the right edge of the page. It's somewhat of a hack but it works and we can't use a real <PageSection> here
  to contain the carousel because the items should be visible outside of a normal page section.
-->
<li
  class={clsx(
    'flex-shrink-0 flex-grow-0 snap-start snap-always last:snap-end last:pr-[max(40px,calc(calc(100vw-min(100vw,var(--page-max-width)))-var(--gutter)))]',
    className,
  )}
>
  <!--
    This translateX() is used to push the items in to the right and make it appear as if the left edge of the carousel is the same as the left edge of the
    page. We need to do this on an extra div like this rather than on the <li> itself because the <li> is what the browser uses to calculate the snap points
    and if we translate the <li> itself the snap points will be off.
  -->
  <div
    class={clsx(
      innerClass,
      'h-full translate-x-[calc(calc(100vw-min(100vw,calc(var(--page-max-width)+var(--gutter)*4)))/2+var(--page-gutter))]',
    )}
  >
    {@render children()}
  </div>
</li>
